export default __webpack_public_path__ + "static/media/profile-cover-1.d5d1dc3b.png";